<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>厂商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>服务网点列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>服务网点列表</span>
        </div>
        <el-button @click="add()" size="small" icon="el-icon-plus" type="primary">添加服务网点</el-button>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="50"></el-table-column>
          <el-table-column prop="title" label="网点名称 " width="180"></el-table-column>
          <el-table-column prop="address" label="地址" width="320"></el-table-column>
          <el-table-column prop="contacts" label="联系人" width="140"></el-table-column>
          <el-table-column prop="mobile" label="联系方式" width="140"></el-table-column>
          <el-table-column prop="stime" label="合作时间" width="140"></el-table-column>
          <el-table-column prop="service" label="服务项目 " width="140"></el-table-column>
          <el-table-column prop="desc" label="备注" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    add() {
      this.$router.push("/factory/add_network");
    },
    edit(ids) {
      this.$router.push({
        path: "/factory/add_network",
        query: {
          id: ids,
        },
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/branch/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/branch/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>